import { Monitor, Moon, Sun } from "lucide-react";
import { cn } from "@/lib/utils";
import { type ThemeChoice, useTheme } from "./ThemeProvider";

const OPTIONS: Array<{ value: ThemeChoice; label: string; Icon: typeof Sun }> = [
  { value: "system", label: "Sistema", Icon: Monitor },
  { value: "light", label: "Claro", Icon: Sun },
  { value: "dark", label: "Escuro", Icon: Moon },
];

/** Seletor de tema em grupo de rádios (setas do teclado navegam entre as opções). */
export function ThemeToggle({ className }: { className?: string }) {
  const { choice, setChoice } = useTheme();
  return (
    <fieldset className={cn("m-0 border-0 p-0", className)}>
      <legend className="sr-only">Tema</legend>
      <div className="grid grid-cols-3 gap-1 rounded-chip bg-surface-2 p-1">
        {OPTIONS.map(({ value, label, Icon }) => (
          <label
            key={value}
            className={cn(
              "flex min-h-11 cursor-pointer items-center justify-center gap-1.5 rounded-control text-sm font-medium",
              "has-focus-visible:outline-2 has-focus-visible:outline-accent",
              choice === value ? "bg-surface text-ink shadow-card" : "text-muted hover:text-ink",
            )}
          >
            <input
              type="radio"
              name="nora-theme"
              value={value}
              checked={choice === value}
              onChange={() => setChoice(value)}
              className="sr-only"
            />
            <Icon aria-hidden="true" className="size-4" />
            {label}
          </label>
        ))}
      </div>
    </fieldset>
  );
}
